<template>
  <div class="APIHomepage_more">
    <div class="more-table-in">
      <div class="more-title">API Account Management</div>
      <el-table
        ref="Usagelist"
        class="table_box table_height_30 table_font_size_14"
        :data="accountsList"
        style="width: 100%"
        empty-text="No Data"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
          v-if="TesRecordsPageData.isShowCheckBtn_AManagment"
        >
        </el-table-column>
        <el-table-column
          prop="apiIdStr"
          label="API ID"
          align="left"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="apiName"
          label="Interface Name"
          align="left"
          show-overflow-tooltip
          min-width="200"
        ></el-table-column>
        <el-table-column
          prop="appKey"
          label="App Key"
          align="left"
          show-overflow-tooltip
          min-width="200"
        ></el-table-column>
        <el-table-column
          prop="secretKey"
          label="Secret Key"
          align="left"
          show-overflow-tooltip
          min-width="200"
        ></el-table-column>
        <el-table-column
          prop="calledCount"
          label="Remaining Calls"
          align="center"
          show-overflow-tooltip
          min-width="150"
        >
          <template slot-scope="scope">
            {{ scope.row.calledCount + "/" + scope.row.totalCount }}
          </template>
        </el-table-column>
        <el-table-column
          prop="expireTime"
          label="Expiration Time"
          align="left"
          show-overflow-tooltip
          min-width="200"
        >
          <template slot-scope="scope">
            {{ $formatDateTime(scope.row.expireTime, "yyyy-MM-dd hh:mm:ss") }}
          </template>
        </el-table-column>
        <el-table-column
          prop="accountStatus"
          label="Status"
          align="left"
          show-overflow-tooltip
          min-width="120"
        >
          <template slot-scope="scope">
            <span
              :class="[
                'point-taskStatus',
                formataccountStatusClass(scope.row.accountStatus),
              ]"
            ></span>
            <span>{{ formataccountStatus(scope.row.accountStatus) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop=""
          label="Operations"
          align="center"
          show-overflow-tooltip
          width="320px"
        >
          <template slot-scope="scope">
            <div>
              <div class="dataClean-operate" @click="toRenew(scope.row)">
                Renew
              </div>
              <div class="dataClean-operate" @click="toExtent(scope.row)">
                Extent
              </div>
              <!-- <div
                class="dataClean-operate"
                @click="toDelete(scope.row)"
                v-if="scope.row.isShowDeleteBtn"
              >
                Delete
              </div> -->
              <div class="dataClean-operate" @click="toTest(scope.row)">
                Test
              </div>
            </div>
          </template>
        </el-table-column>
        <template slot="empty">
          <div>
            <img
              style="width: 50%; height: 50%"
              src="../../../assets/images/noDate.png"
              alt=""
            />
          </div>
        </template>
      </el-table>
      <div class="page_i_box dataService">
        <Page
          :totalFont="true"
          :total="page.total"
          :pageSize.sync="page.pageSize"
          :currentPage="page.pageNo"
          @onPageChange="onPageChangeList"
        ></Page>

        <div class="search_rsult_txt line_2">
          {{ page.pageNo }}-{{ page.pageSize }} of over
          {{ page.total | FilterNum }} results for "Data API"
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getAccountsPage,
  deleteAccount,
  renewalCount,
  renewalExpireTime,
} from "@/api/dataServicesApi";
import crypto from "@/utils/crypto";
import Page from "@/components/page/index.vue";
export default {
  props: ["TesRecordsPageData"],
  data() {
    return {
      accountsList: [],
      accountStatusOptions: [
        {
          value: "1",
          label: "NORMAL",
          class: "NORMAL",
        },
        {
          value: "2",
          label: "BLOCKED",
          class: "BLOCKED",
        },
        {
          value: "3",
          label: "LIMITED",
          class: "LIMITED",
        },
        {
          value: "4",
          label: "EXPIRED",
          class: "EXPIRED",
        },
        {
          value: "5",
          label: "TIMESUSEDUP",
          class: "TIMESUSEDUP",
        },
        {
          value: "6",
          label: "APPLYING",
          class: "APPLYING",
        },
      ],
      page: {
        pageSize: 10,
        pageNo: 1,
        total: 0,
      },
    };
  },
  components: {
    Page,
  },
  computed: {},
  watch: {},
  created() {
    this.getAccountsPageData();
  },
  mounted() {},
  methods: {
    getAccountsPageData() {
      let params = {
        page: this.page.pageNo,
        pageSize: this.page.pageSize,
        // env:1,//1测试2生产
        accountStatus: "", //账号状态
        apiName: "", //接口名称
        apiUrl: "",
        appKey: "",
        createStartTime: "",
        createEndTime: "",
        expireStartTime: "",
        expireEndTime: "",
      };
      getAccountsPage(params).then((res) => {
        if (res.code == 200) {
          this.accountsList = JSON.parse(JSON.stringify(res.data.rows));
          this.accountsList.forEach((item, index) => {
            item.secretKey = crypto.decrypt(item.secretKey); //解密
            if (item.createTime) {
              //计算是否大于30天按钮才会显示
              let isMoreThan30Days = this.isMoreThan30Days(
                +new Date(item.createTime),
              );
              this.$set(
                this.accountsList[index],
                "isShowDeleteBtn",
                isMoreThan30Days,
              );
            }
          });
          console.log("this.accountsList", this.accountsList);
          this.page.total = res.data.total;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 对比时间
    isMoreThan30Days(createdAt) {
      const now = new Date(); // 当前时间
      const created = new Date(createdAt); // 创建时间（支持字符串、时间戳等）

      // 计算时间差（毫秒）
      const diffInMs = now - created;

      // 转换为天数（1天 = 24 * 60 * 60 * 1000 毫秒）
      const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

      return diffInDays > 30;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    onPageChangeList({ page, size }) {
      this.page.pageSize = size;
      this.page.pageNo = page;
      this.getAccountsPageData()
    },
    formataccountStatus(status) {
      const item = this.accountStatusOptions.find(
        (item) => item.value == status,
      );
      return item ? item.label : null;
    },
    formataccountStatusClass(status) {
      const item = this.accountStatusOptions.find(
        (item) => item.value == status,
      );
      return item.class;
    },
    // 续次数
    toRenew(row) {
      let params = {
        id: row.id,
      };
      renewalCount(params).then((res) => {
        if (res.code == 200) {
          this.$message.success(res.msg);
          this.getAccountsPageData();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 续时间
    toExtent(row) {
      let params = {
        id: row.id,
      };
      renewalExpireTime(params).then((res) => {
        if (res.code == 200) {
          this.$message.success(res.msg);
          this.getAccountsPageData();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 删除
    toDelete(row) {
      let params = {
        id: row.id,
      };
      deleteAccount(params).then((res) => {
        if (res.code == 200) {
          this.$message.success(res.msg);
          this.getAccountsPageData();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 跳转到test页面
    toTest(row) {
      console.log('row',row);
      this.$router.push({
        name: "Test",
        query: { apiName: row.apiName, appKey: row.appKey },
      });
    },
  },
};
</script>

<style scoped>
.APIHomepage_more {
  background-color: #fff;
  border-radius: 10px;
  margin-bottom: 50px;
}
.more-title {
  color: #1a2332;
  font-size: 20px;
  margin-bottom: 30px;
  font-weight: bold;
}
/* 表格样式 */
.more-table-in {
  /* max-height:calc(100vh - 153px); */
  background: #ffffff;
  box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  padding: 30px 40px;
}
.more-table-in /deep/ .el-table__empty-text {
  padding: 85px 0;
}
.more-table-in /deep/ th.el-table__cell {
  background: #f3f3f3;
}
.more-table-in /deep/ td.el-table__cell {
  height: auto;
  padding: 18px 0;
}
.more-table-in /deep/ th.el-table__cell {
  padding: 13px 0;
}
.more-table-in /deep/ .cell {
  font-size: 16px ;
}
.more-table-in /deep/ .el-table__expand-icon {
  display: block !important;
}
.more-table-in /deep/ .el-table__expand-icon .el-icon-arrow-right {
  left: 50%;
  top: 50%;
  margin: 0;
  right: auto;
  transform: translate(-50%, -50%) rotate(90deg);
}
.more-table-in
  /deep/
  .el-table__expand-icon.el-table__expand-icon--expanded
  .el-icon-arrow-right {
  transform: translate(-50%, -50%) rotate(180deg);
}
.more-table-in /deep/ .el-table__expanded-cell {
  background: #f0f0f0 !important;
  padding: 14px !important;
}
.more-table-in /deep/ .el-table__expanded-cell:hover {
  background: #f0f0f0 !important;
}
.more-table-in /deep/ .expanded td.el-table__cell {
  border-bottom: 0 !important;
}
.more-table-in /deep/ .tree_table_box {
  padding: 0 !important;
}
.more-table-in .dataClean-operate {
  font-size: 18px;
  color: #b98b73;
  height: 15px;
  line-height: 15px;
  padding: 0 15px;
  white-space: nowrap;
  cursor: pointer;
  display: inline-block;
}
.more-table-in .dataClean-operate:not(:last-child) {
  border-right: 1px solid #d3d3d3;
}
.more-table-in .dataClean-operate:first-of-type {
  padding-left: 0;
}
.more-table-in .dataClean-operate:last-of-type {
  padding-right: 0;
}
.point-taskStatus {
  width: 8px;
  height: 8px;
  background: #ccc;
  display: inline-block;
  vertical-align: middle;
  border-radius: 50%;
  margin-right: 8px;
}
.point-taskStatus.NORMAL {
  background: #02815c;
}
.point-taskStatus.BLOCKED {
  background: #f55656;
}
.point-taskStatus.LIMITED {
  background: #7e50ff;
}
.point-taskStatus.EXPIRED {
  background: #2a77eb;
}
.point-taskStatus.TIMESUSEDUP {
  background: #be8ff2;
}
.point-taskStatus.APPLYING {
  background: #ffcc00;
}
/* 大版本及中版本：media的范围（1920px至1440px）; */
@media (max-width: 1920px) {
  /* 字体 标题改成20px */
  /* 字体 内容改成16px 包括按钮里字体*/
  .more-table-in .dataClean-operate,.search_rsult_txt,.page_txt{
    font-size:16px;
  }
  /* 圆角 改成10px */
  .more-table-in{
    border-radius:10px;
  }
  /* padding *0.75 */
  .more-table-in{
    padding:23px 30px;
  }
  /* margin *0.75 */
  .more-title{
    margin-bottom:23px;
  }
   /* 表格 表头高度 44px 内容高度50px */
   .more-table-in /deep/ thead {
    height: auto !important;
  }
  .more-table-in /deep/ th.el-table__cell,
  .more-table-in /deep/ .has-gutter .el-table__cell {
    height: auto !important;
    padding: 7px 0;
  }
  .more-table-in /deep/ td.el-table__cell {
    padding: 10px 0;
  }
}
/* 小版本：media的范围（1440px以下）; */
@media (max-width: 1440px) {
  /* 字体 标题改成18px */
  .more-title{
    font-size:18px;
  }
  /* 字体 内容改成14px 包括按钮里字体*/
  .more-table-in /deep/ .cell ,.more-table-in .dataClean-operate,.search_rsult_txt,.page_txt{
    font-size:14px;
  }
  /* 圆角 改成8px */
  .more-table-in{
    border-radius:8px;
  }
  /* padding *0.67 */
  .more-table-in{
    padding:20px 27px;
  }
  /* margin *0.67 */
  .more-title{
    margin-bottom:20px;
  }
  /* 表格 表头高度 40px 内容高度44px*/
  .more-table-in /deep/ thead {
    height: auto !important;
  }
  .more-table-in /deep/ th.el-table__cell,
  .more-table-in /deep/ .has-gutter .el-table__cell {
    height: auto !important;
    padding: 10px 0;
  }
  .more-table-in /deep/ td.el-table__cell {
    padding: 13px 0;
  }
}
</style>
